module.exports = __webpack_public_path__ + "static/media/sliderimage3.d2b3beb9.jpg";